import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter, Routes } from '@angular/router';
import { AppComponent } from './app/app.component';
import { HomeComponent } from './app/home/home.component';
import { GodotDemoComponent } from './app/godot-demo/godot-demo.component';
import { PlayComponent } from './app/play/play.component';
import { VillagePageComponent } from './app/village-page/village-page.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'play', component: PlayComponent },
  { path: 'godot-demo', component: GodotDemoComponent, data: { mode: 'screen' } },
  { path: 'godot-demo/:roomCode', component: GodotDemoComponent, data: { mode: 'screen' } },
  { path: 'godot-screen', component: GodotDemoComponent, data: { mode: 'screen' } },
  { path: 'godot-screen/:roomCode', component: GodotDemoComponent, data: { mode: 'screen' } },
  { path: 'godot-phone', component: GodotDemoComponent, data: { mode: 'phone' } },
  { path: 'godot-phone/:roomCode', component: GodotDemoComponent, data: { mode: 'phone' } },
  { path: 'phone', redirectTo: 'godot-phone' },
  { path: 'phone/:roomCode', redirectTo: 'godot-phone/:roomCode' },
  { path: 'screen', redirectTo: 'godot-screen' },
  { path: 'screen/:roomCode', redirectTo: 'godot-screen/:roomCode' },
  {
    path: 'about',
    component: VillagePageComponent,
    data: {
      location: 'Guild Hall',
      title: 'About Acorn Guild',
      description: 'Acorn Guild is a cozy couch co-op village where friends use phones as controllers and gather around one shared screen.'
    }
  },
  {
    path: 'games',
    component: VillagePageComponent,
    data: {
      location: 'Market',
      title: 'Games',
      description: 'A managed list of playable prototypes, future modes, and guild experiments will live here.'
    }
  },
  {
    path: 'news',
    component: VillagePageComponent,
    data: {
      location: 'Tavern',
      title: 'News & Updates',
      description: 'Patch notes, playtest announcements, and community updates will be gathered here.'
    }
  },
  {
    path: 'library',
    component: VillagePageComponent,
    data: {
      location: 'Library',
      title: 'How To Play',
      description: 'Guides, room setup, controller instructions, and future game rules will be stored here.'
    }
  },
  {
    path: 'contact',
    component: VillagePageComponent,
    data: {
      location: 'Guild Hall',
      title: 'Contact',
      description: 'Contact links, community channels, and playtest signup details will go here.'
    }
  },
  { path: '**', redirectTo: '' }
];

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    provideRouter(routes)
  ]
}).catch((error) => console.error(error));
